import View from '@shared/components/layout-default/layout-default-router-view';

export const worksheet = {
  path: 'worksheets',
  component: View,
  children: [
    {
      path: '',
      name: 'pbx.worksheet.index',
      component: () => import(/* webpackChunkName: 'pbx-worksheet' */ '@pbx/pages/worksheets/list'),
      meta: {
        title: {
          code: 'pbx.breadcrumb.worksheet.index'
        }
      }
    }
  ]
};
